import settings from '@nobia/zeus-components/lib/settings'

export const isDev = process.env.NODE_ENV !== 'production'

export const cdnProxy = url =>
  `${settings.cloudinaryFetchUrl}${encodeURIComponent(url)}`

export const cdnImage = image =>
  isDev ? image : cdnProxy(`${settings.origin || ''}${image}`)
